import React from "react";
import classes from "./AboutHero.module.css";

const AboutHero = () => {
  return (
    <div className={classes.container}>
      <h3>About Us</h3>
    </div>
  );
};

export default AboutHero;
